module.exports = __webpack_public_path__ + "img/work.a5914faf.jpg";